import { ENTITY_CONFIG } from "config/entityConfig";

/**
 * Get entities for a specific context
 * @param {string} context - 'FAQ', 'SUBSCRIPTION', 'TESTIMONIAL'
 * @returns {Object} Entities configuration for the context
 */
export const getEntitiesForContext = (context) => {
  return ENTITY_CONFIG[context] || {};
};

/**
 * Get all available contexts
 * @returns {Array} List of available contexts
 */
export const getAvailableContexts = () => {
  return Object.keys(ENTITY_CONFIG);
};

/**
 * Get entity config for specific context and entity type
 * @param {string} context - Context name
 * @param {string} entityType - Entity type
 * @returns {Object|null} Entity configuration
 */
export const getEntityConfig = (context, entityType) => {
  return ENTITY_CONFIG[context]?.[entityType] || null;
};

export const normalizeEntityOverrides = (pricing) => {
  if (!pricing || !Array.isArray(pricing.entityOverrides)) return pricing;

  return {
    ...pricing,
    entityOverrides: pricing.entityOverrides.map((item) => ({
      ...item,
      entityType: item.entityType?.toLowerCase(),
    })),
  };
};

